<template>
	<v-dialog
		v-if="open"
		:content-class="`dialog-over-product-catalog single-to-menu-dialog ${featureToggles.verticalKioskBasket ? 'single-to-menu-upgrade-dialog-vertical-kiosk': ''}`"
		v-model="open"
	>
		<v-layout column class="kiosk-modal single-to-menu-layout">
			<div class="black-background">
				<v-btn
					icon
					@click="onClose"
					class="close-btn"
				>
					<img class="close-image" src="../../../../../static/tid100/images/icons/x-close.svg"/>
				</v-btn>
				<v-flex wrap>
					<v-flex class="single-to-menu-product-name">
						{{ item.product.name | translate(`product.${item.product.id}.name`) }}
					</v-flex>
					<v-flex class="single-to-menu-addons">
						{{question}}
					</v-flex>
					<v-flex xs12 class="flex-horizontal-center upgrade-img-wrapper">
						<v-flex :class="{'upgrade-product-wrapper': featureToggles.singleProductToMenuUpgradeWithNewDesign}">
							<v-flex class="upgrade-product">
								<SmartImg
									:product="menuItem ? menuItem.product : item.product"
									:backImg="backImg"
									@click="onClick1"
									class="menu-product"
									data-cy="upgrade-to-large-menu"
								>
									<div class="label bow bow-left">
										{{label}}
									</div>
									<div>
										<div class="product-title">
											{{text1}}
											<span
												v-if="menuItem && menuItem.priceDifference"
												class="additional-price"
											>
											{{menuItem.priceDifference > 0 ? "+" : ""}}{{formatPriceZero(menuItem.priceDifference)}}
										</span>
										</div>
										<div class="promo-text">
											{{promoText}}
										</div>
									</div>
								</SmartImg>
								<div v-if="makeMenuText" class="menu-single-text">
									{{ makeMenuText }}
								</div>
								<div v-if="friesAndRefillText" class="refill-section">
									<div class="refill-text">
										{{ friesAndRefillText }}
									</div>
									<img :src="getImage('upgrade-to-menu-arrow.svg')" alt="upgrade-to-menu-arrow">
								</div>
							</v-flex>
							<v-flex class="upgrade-product">
								<SmartImg
									:product="item.product"
									:backImg="backImg"
									@click="onClick2"
									class="single-product"
									data-cy="upgrade-to-menu"
								>
									<div class="product-title">
										{{text2}}
									</div>
								</SmartImg>
								<div v-if="singleMenuText" class="menu-single-text">
									{{ singleMenuText }}
								</div>
							</v-flex>
						</v-flex>
					</v-flex>
				</v-flex>
			</div>
		</v-layout>
	</v-dialog>
</template>

<script>
import { mapGetters} from "vuex";
import * as Utils from "../../../../libraries/utils";
import {pushGTMInternal} from "../../../../integrations/tracking/gtm/pushGtmEvents";
import appConfig from "../../../../appconfig";
import SmartImg from "./SmartImg.vue";

export default {
	name: "UpgradeToMenuDialog",
	components: {SmartImg},
	props: ["item", "menuItem", "opened", "onClose", "formatPriceZero", "backImg", "onClick1", "onClick2", "question", "text1", "text2", "label", "promoText", "makeMenuText", "singleMenuText", "friesAndRefillText"],
	computed: {
		...mapGetters(["featureToggles", "tenantSpecificData", "globalSelectedShop"]),
		open: {
			get() {
				return this.opened;
			},
			set() {
				this.onClose();
			}
		}
	},
	mounted() {
		if(appConfig.isBM100()) {
			pushGTMInternal(
				"SSpageview",
				"Upgrade to menu",
				this.$route.path,
				"",
				{
					email: (this.$store.getters.personData || {}).email,
					selectedRestaurant: this.globalSelectedShop.shopName
				}
			);
		}
	},
	methods: {
		getImage(imageName) {
			return Utils.getMiscImageUrl(imageName);
		}
	}
};
</script>
<style scoped lang="scss">
.upgrade-product {
	width: 50%;
}
.upgrade-product-wrapper {
	padding: 50px 150px;
	justify-content: space-between;
	.upgrade-product {
		flex-direction: column;
		flex: 0 1 auto;
		width: 48%;
		position: relative;
		.single-product, .menu-product {
			width: 100% !important;
			margin: 0 0 40px 0 !important;
		}
		.menu-single-text {
			font-weight: bold;
			font-size: 28px;
			line-height: 22px;
			text-align: center;
			min-height: 50px;
		}
		.refill-section {
			position: absolute;
			bottom: 460px;
			left: -95px;
			width: 180px;
			transform: rotate(-15deg);
			.refill-text {
				font-family: 'GrapeNuts';
				font-size: 27px;
				line-height: 1;
			}
			img {
				padding-right: 50px;
			}
		}
	}
}
@media screen and (max-width: 1537px) {
	/deep/ .v-dialog.dialog-over-product-catalog.single-to-menu-dialog {
		max-width: calc(90% - 242px);
	}
	.upgrade-product-wrapper .upgrade-product .refill-section {
		bottom: 430px;
	}
}
@media screen and (max-width: 1440px) {
	.upgrade-product-wrapper {
		.upgrade-product {
			.menu-single-text, .refill-section .refill-text {
				font-size: 22px;
			}
			.refill-section {
				bottom: 390px;
			}
		}
	}
}
@media screen and (max-width: 1366px) {
	.upgrade-product-wrapper {
		.upgrade-product {
			.refill-section {
				bottom: 360px;
			}
		}
	}
}
@media screen and (max-width: 1280px) {
	.upgrade-product-wrapper {
		.upgrade-product {
			.refill-section {
				bottom: 360px;
				left: -110px;
			}
		}
	}
}
@media screen and (max-width: 500px) {
	/deep/.v-dialog.dialog-over-product-catalog.single-to-menu-dialog {
		max-width: 100%;
		touch-action: none;
		.upgrade-product-wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 0;
			margin-top: 80px;
			.upgrade-product {
				.single-product, .menu-product {
					margin: 0 0 75px 0 !important;
				}
				&:has(.menu-single-text) {
					.single-product, .menu-product {
						margin: 0 0 15px 0 !important;
					}
				}
				.menu-single-text {
					font-size: 16px;
					color: #ffffff;
				}
				.refill-section {
					font-family: 'GrapeNuts';
					width: 115px;
					bottom: 250px;
					left: -75px;
					.refill-text {
						color: #ffffff;
						font-size: 16px;
					}
					img {
						padding-right: 0;
						width: 14px;
					}
				}
			}
		}
	}
	.upgrade-product {
		width: 100%;
	}
}

@media screen and (max-width: 375px) {
	/deep/.v-dialog.dialog-over-product-catalog.single-to-menu-dialog {
		.upgrade-product-wrapper .upgrade-product {
			.single-product, .menu-product {
				height: 180px;
			}
			.refill-section {
				bottom: 230px;
			}
		}
	}
}
</style>
